module.exports = __webpack_public_path__ + "img/ythopper.ed752d18.png";